import PropTypes from 'prop-types';

export const dropdownOptionPropType = PropTypes.shape({
  // The displayed text of the option
  label: PropTypes.string,
  // The value of the option - would be some sort of id in most cases
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});
